/* Shop the look — click/swipe through a look's extra images without leaving the page */
(function () {
  function initCard(item) {
    var track = item.querySelector('[data-stl-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.stl-slide');
    if (slides.length <= 1) return;

    var prevBtn = item.querySelector('[data-stl-prev]');
    var nextBtn = item.querySelector('[data-stl-next]');
    var dots = item.querySelectorAll('[data-stl-dot]');
    var index = 0;

    function render() {
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(newIndex, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      index = (newIndex + slides.length) % slides.length;
      render();
    }

    function stop(event) {
      // Keep the click on the arrows/dots from also following the card's <a href>.
      event.preventDefault();
      event.stopPropagation();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) { goTo(index - 1, e); });
      prevBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') goTo(index - 1, e);
      });
      prevBtn.addEventListener('mousedown', stop);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) { goTo(index + 1, e); });
      nextBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') goTo(index + 1, e);
      });
      nextBtn.addEventListener('mousedown', stop);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) { goTo(i, e); });
      dot.addEventListener('mousedown', stop);
    });

    // Touch swipe
    var touchStartX = 0;
    var touchDeltaX = 0;
    var touching = false;

    track.addEventListener('touchstart', function (e) {
      touching = true;
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!touching) return;
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!touching) return;
      touching = false;
      if (Math.abs(touchDeltaX) > 40) {
        goTo(touchDeltaX < 0 ? index + 1 : index - 1, e);
      }
      touchDeltaX = 0;
    });

    // Mouse drag swipe (desktop)
    var dragging = false;
    var dragStartX = 0;
    var dragDeltaX = 0;

    track.addEventListener('mousedown', function (e) {
      dragging = true;
      dragStartX = e.clientX;
      dragDeltaX = 0;
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      dragDeltaX = e.clientX - dragStartX;
    });

    window.addEventListener('mouseup', function (e) {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(dragDeltaX) > 40) {
        goTo(dragDeltaX < 0 ? index + 1 : index - 1, e);
      }
      dragDeltaX = 0;
    });

    render();
  }

  function init() {
    document.querySelectorAll('.stl-item').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when blocks are added/edited in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
